import { getRequest, postRequest, putRequest, paginationQuery, filterQuery, sortQuery, deleteRequest } from './seviceHelpers';

const getTeamIdRequest = (teamId, path) => {
    if (typeof teamId === 'undefined' || teamId === null) {
        throw new Error('monitor service request without teamId');
    }
    return getRequest(`/teams/${teamId}${path}`);
};

/**
 * API requests starting with /teams
 */
export default {
    getById: async teamId => getTeamIdRequest(teamId, '?include=location,channel,feature'),
    getMonitors: (teamId, filter, pagination, sort) =>
        getTeamIdRequest(
            teamId,
            '/monitors?include=incident,availability,latency'.concat(
                pagination ? `&${paginationQuery(pagination)}` : '',
                filter ? `&${filterQuery(filter)}` : '',
                sortQuery(sort),
            ),
        ),
    getMonitorsBare: teamId =>
        getTeamIdRequest(teamId, '/monitors?page[size]=200&sort=name'),
    getChecks: async teamId => getTeamIdRequest(teamId, '/checks'),
    getIncidents: async (teamId, filter, pagination) => getTeamIdRequest(teamId, `/incidents?include=monitor${pagination ? `&${paginationQuery(pagination)}` : ''}${filter ? `&${filterQuery(filter)}` : ''}`),
    getAvailability: async teamId => getTeamIdRequest(teamId, '/availability?precision=daily'),
    getLatency: async teamId => getTeamIdRequest(teamId, '/latency?precision=daily'),
    getGroups: async teamId => getTeamIdRequest(teamId, '/groups'),
    getGroupAvailability: async (teamId, group) => getTeamIdRequest(teamId, `/groups/${group}/availability`),
    getGroupLatency: async (teamId, group) => getTeamIdRequest(teamId, `/groups/${group}/latency`),

    enableFeature: async (teamId, feature, settings) => postRequest(`/teams/${teamId}/features`, {
        data: { type: 'feature', attributes: { feature, settings } },
    }),
    updateFeature: async (teamId, feature, settings) => putRequest(`/teams/${teamId}/features`, {
        data: { type: 'feature', attributes: { feature, settings } },
    }),

    setupIntent: async teamId => postRequest(`/teams/${teamId}/setup-intent`),
    savePaymentMethod: async (teamId, paymentMethod) => postRequest(`/teams/${teamId}/payment-method`, {
        data: { type: 'paymentMethod', paymentMethod },
    }),
    activateSubscription: async (teamId, interval, monitors, currency) => postRequest(`/teams/${teamId}/subscription`, {
        data: {
            type: 'activateSubscription', interval, monitors, currency,
        },
    }),
    cancelSubscription: async teamId => deleteRequest(`/teams/${teamId}/subscription`),
    canSubscribe: async teamId => getRequest(`/teams/${teamId}/subscription`), // not used?
    getCustomer: async teamId => getRequest(`/teams/${teamId}/customer`),
    putCustomer: async (teamId, customer) => putRequest(`/teams/${teamId}/customer`, customer),
    creditsRecharge: async (teamId, attributes) => postRequest(`/teams/${teamId}/credits-recharge`, {
        data: {
            type: 'creditsRecharge', attributes,
        },
    }),

    getCoupon: async id => getRequest(`/team/${id}/coupon`),
    applyCoupon: async (id, promoCode) => postRequest(`/team/${id}/coupon`, {
        data: {
            type: 'coupon', attributes: { promoCode },
        },
    }),

    startTrial: async teamId => postRequest(`/teams/${teamId}/trial`),
};
